import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { E_FOLDER_TYPES, E_QPROPS } from '@shared/constants/enums.const';
import { HelperService } from '../../../services/helper.service';
import { IRelatedTag } from '@shared/constants/models.const';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-tag-item',
  imports: [
    RouterLink,
  ],
  templateUrl: './tag-item.component.html',
  styleUrl: './tag-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagItemComponent implements OnInit {

  tag = input<IRelatedTag>();
  tagTitle = input<string>('Tag');
  tagUrl = input<string>('');
  params: any;

  constructor(
    public HELPER: HelperService,
  ) {}

  ngOnInit(): void {
    this.params = { [E_QPROPS.contentType]: this.HELPER.getAllCategoriesSum() };
  }

  getUrl() {
    return this.HELPER.getUrl(`${E_FOLDER_TYPES.TagRelated}/${this.tag()?.id}`);
  }

}
